/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import cn from 'clsx';
import { ReactComponent as CommonFileSvg } from 'assets/icons/files/Common.svg';
import { ReactComponent as FolderSvg } from 'assets/icons/files/Folder.svg';
import { AModal, AButton } from 'components/Antd';
import { ReactComponent as ArrowRightSvg } from 'assets/icons/New/arrow-right-icon.svg';
import emptyFolder from 'assets/img/productDetail_empty_folder.jpg';
import T from 'i18n-react';
import classes from './MoveModal.module.scss';

const MoveModal = ({ open, onClose, onSubmit, items, defaultSelectedFolders, onLoadFiles }) => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentFilesFolders, setCurrentFilesFolders] = useState([]);
  const [folderList, setFolderList] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const lastDefaultFolderId = defaultSelectedFolders?.[defaultSelectedFolders?.length - 1]?.id;
  const lastCurrentFolderId = folderList?.[folderList?.length - 1]?.id;
  const itemLength = items?.length || 0;
  const currentFiles = currentFilesFolders.filter((item) => !item.isFolder);
  const currentFolders = currentFilesFolders.filter((item) => !!item.isFolder);
  const handleSelectFolder = (tFolder, isAppend) => {
    if (isAppend) {
      setFolderList((prev) => {
        return [...prev, tFolder];
      });
      handleLoadFiles(tFolder?.id);
    } else {
      if (!tFolder) {
        setFolderList([]);
        handleLoadFiles('');
      } else {
        const tIndex = findIndex(folderList, (item) => item.id === tFolder.id);
        const cloneFolders = [...folderList];
        const remaining = cloneFolders.slice(0, tIndex + 1);
        setFolderList(remaining);
        handleLoadFiles(remaining?.[remaining?.length - 1]?.id);
      }
    }
  };
  const handleLoadFiles = (tFolderId) => {
    setFetchLoading(true);
    setCurrentFilesFolders([]);
    onLoadFiles(tFolderId, (res) => {
      const tAllFiles = res?.data?.data?.list || [];
      setCurrentFilesFolders(
        tAllFiles.map((obj) => {
          const documentList = obj.documentList || {};
          return {
            ...obj,
            ...documentList,
            isFolder: isEmpty(documentList),
            name: documentList.name || obj.folderName,
            id: documentList.id || obj.id,
            originalId: obj.id,
          };
        })
      );
      setFetchLoading(false);
    });
  };

  useEffect(() => {
    if (onLoadFiles) {
      handleLoadFiles(defaultSelectedFolders?.[defaultSelectedFolders?.length - 1]?.id);
    }
    setFolderList(defaultSelectedFolders || []);
  }, []);

  return (
    <AModal
      title={`Move ${itemLength} Item${itemLength === 1 ? '' : 's'}`}
      open={open}
      onCancel={onClose}
      closable
      width={480}
      className={cn(classes.modalWrapper)}>
      <div className={classes.content}>
        <div className={classes.breadcrumb}>
          {folderList?.length > 0 ? (
            <>
              <span
                className={classes.link}
                onClick={() => {
                  handleSelectFolder(null);
                }}>
                Document - All
              </span>
              <span>
                <ArrowRightSvg />
              </span>
              {folderList.map((item, index) => {
                const isLast = index === folderList.length - 1;
                return (
                  <React.Fragment key={item.id}>
                    <span
                      key={item.id}
                      onClick={() => {
                        if (!isLast) {
                          handleSelectFolder(item);
                        }
                      }}
                      className={cn({
                        [classes.link]: !isLast,
                      })}>
                      {item.name}
                    </span>
                    {!isLast && (
                      <span>
                        <ArrowRightSvg />
                      </span>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          ) : (
            <span>Document - All</span>
          )}
        </div>
        {currentFilesFolders.length > 0 ? (
          <ul className={classes.listFilesFolders}>
            {[...currentFolders, ...currentFiles].map((item, index) => {
              const isFolder = item.isFolder;
              return (
                <li
                  key={`${item.id}_${index}`}
                  onClick={
                    isFolder
                      ? () => {
                          handleSelectFolder(item, true);
                        }
                      : undefined
                  }
                  className={cn({
                    [classes.folderItem]: isFolder,
                  })}>
                  <span>
                    {isFolder ? <FolderSvg /> : <CommonFileSvg />}
                    <span>{item.name}</span>
                  </span>
                  {isFolder && (
                    <span>
                      <ArrowRightSvg />
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <>
            {!fetchLoading && (
              <div className={classes.emptyBlock}>
                <img src={emptyFolder} alt="empty-folder" />
                <span>This folder is empty</span>
              </div>
            )}
          </>
        )}
      </div>
      <div className={classes.footer}>
        <AButton
          htmlType="button"
          type="primary"
          size="large"
          onClick={() => {
            if (onSubmit) onSubmit(lastCurrentFolderId);
          }}
          disabled={lastDefaultFolderId === lastCurrentFolderId}
          className={classes.confirmBtn}>
          Move here
        </AButton>
      </div>
    </AModal>
  );
};

export default MoveModal;
